import 'css-chunk:src/shared/Loader.module.scss';export default {
  "loaderContainer": "_loaderContainer_1p09y_1",
  "loader": "_loader_1p09y_1",
  "spin": "_spin_1p09y_1"
};